module.exports = __webpack_public_path__ + "static/media/pfiff-code.64e8257c.png";